module.exports = __webpack_public_path__ + "img/product_35.fe4c264.svg";